"use client";
import React from "react";
import { StatCard } from "./../components/dashboard/StatCard";
import { LineChart } from "./../components/dashboard/LineChart";
import { BarChart } from "./../components/dashboard/BarChart";
import { DoughnutChart } from "./../components/dashboard/DoughnutChart";
import TopBarSignedIn from "../components/common/TopBarSignedIn";

export const Dashboard = () => {
    // Sample data
    const activityData = [10, 25, 15, 30, 20, 35, 25];
    const monthlyData = [
        { label: "Jan", value: 20 },
        { label: "Feb", value: 35 },
        { label: "Mar", value: 25 },
        { label: "Apr", value: 40 },
        { label: "May", value: 30 },
    ];
    const distributionData = [
        { label: "Posts", value: 45, color: "#3b82f6" },
        { label: "Topics", value: 30, color: "#10b981" },
        { label: "Documents", value: 25, color: "#f59e0b" },
    ];

    return (
        <div className="w-full bg-white min-h-screen">
            <TopBarSignedIn />
            <main className="flex flex-col gap-6 p-6 mx-auto w-full max-w-[1272px] max-sm:px-4">
                <div className="min-h-screen bg-gray-50 p-8 rounded-lg">
                    <header className="mb-8">
                        <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>
                        <p className="text-gray-600">Overview of your community activity</p>
                    </header>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                        <StatCard
                            title="Total Posts"
                            value="2,567"
                            trend={12}
                            icon={
                                <svg
                                    className="w-6 h-6 text-blue-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                                    />
                                </svg>
                            }
                        />
                        <StatCard
                            title="Active Topics"
                            value="189"
                            trend={-5}
                            icon={
                                <svg
                                    className="w-6 h-6 text-green-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                                    />
                                </svg>
                            }
                        />
                        <StatCard
                            title="Documents"
                            value="432"
                            trend={8}
                            icon={
                                <svg
                                    className="w-6 h-6 text-yellow-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                    />
                                </svg>
                            }
                        />
                        <StatCard
                            title="Members"
                            value="1,234"
                            trend={15}
                            icon={
                                <svg
                                    className="w-6 h-6 text-purple-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                    />
                                </svg>
                            }
                        />
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                        <LineChart data={activityData} width={600} height={300} />
                        <BarChart data={monthlyData} width={600} height={300} />
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <DoughnutChart data={distributionData} size={300} />
                        <div className="bg-white rounded-xl p-6 shadow-sm">
                            <h3 className="text-gray-700 font-medium mb-4">Recent Activity</h3>
                            <div className="space-y-4">
                                {[1, 2, 3, 4].map((item) => (
                                    <div
                                        key={item}
                                        className="flex items-center gap-4 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                                    >
                                        <div className="w-2 h-2 rounded-full bg-blue-500" />
                                        <div className="flex-1">
                                            <p className="text-sm text-gray-800">
                                                New post in Technology
                                            </p>
                                            <p className="text-xs text-gray-500">2 hours ago</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Dashboard;
